:host {
  --loader-height: 24px;
  --split-row-height: 52px;
  --loader-border-radius: 16px;
  --loader-padding-bottom: 10px;
}

.item {
  border-radius: var(--loader-border-radius);
  background-color: var(--gz-loader-background);
  height: var(--loader-height);
  position: relative;
  overflow: hidden;
  flex: 1;

  .loader {
    content: '';
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      var(--loader-gradient-angle, 270deg),
      transparent,
      var(--gz-loader-animation-bg) 50%,
      transparent
    );
    animation: var(--animation);
  }
}

.loader-columns {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;
  margin-bottom: var(--loader-padding-bottom);
  height: var(--loader-height);

  &:last-of-type {
    margin-bottom: 0;
  }

  .item {
    &.has-columns {
      flex: initial;
    }
  }
}

// for now support 12 columns of loaders
$columns: 12;
@for $i from 2 through $columns {
  .width-#{$i} {
    width: calc((100% / #{$i}) - calc(2 * var(--spacer)));
  }
}

@keyframes glow {
  100% {
    transform: translateX(100%);
  }
}

:host([splitRowsByLine]),
:host([splitColumnsByLine]) {
  .loader-columns {
    height: var(--split-row-height);
    align-items: center;
    margin-bottom: 0px;
    padding: 0 calc(2 * var(--spacer));
  }
}

:host([splitRowsByLine]) {
  .loader-columns {
    border-bottom: 1px solid var(--chart-101-pressed-dividers);
  }
}

:host([splitColumnsByLine]) {
  .vertical-bar {
    &:not(:last-of-type) {
      width: 1px;
      height: 100%;
      background-color: var(--chart-101-pressed-dividers);
    }
  }
}
